import { useState, useEffect } from 'react';

// 모바일 사이즈인지 확인하는 hook
const useIsMobile = (maxWidth = 768): boolean => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < maxWidth);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < maxWidth);
    };

    window.addEventListener('resize', handleResize);
    // 컴포넌트가 마운트될 때 현재 상태를 설정
    handleResize();

    // 컴포넌트가 언마운트될 때 이벤트 리스너를 정리
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [maxWidth]);

  return isMobile;
};

export default useIsMobile;
